module.exports = __webpack_public_path__ + "img/21.56af18a1.png";